import { i18n } from '../../i18n/i18n'

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { connect, ConnectedProps } from 'react-redux'
import { find } from 'lodash'
import { RootState } from '../../store'
import routes from '../../routes/routes'
import palletApi from '../../apis/pallet.api'
import inventoryApi from '../../apis/inventory.api'
import confirmService from '../../services/confirm.service'
import printService from '../../services/print.service'
import alertService from '../../services/alert.service'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import { replacePage, replaceLimit, replaceSearch } from './Receivings.slice'
import { paginate, deleteReceiving } from './Receivings.thunk'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import DataTable from '../../components/DataTable'
import { TableHorizontalHeader } from '../../components/TableHorizontal'
import { ActionName } from '../../components/Actions'
import Button from '../../components/Button'
import HeadingRow from '../../components/HeadingRow'
import { WatermarkHelper } from '../../components/WatermarkHelper'

interface ReceivingsProps
    extends RouteComponentProps, ConnectedProps<typeof connector> {
}

class Receivings extends Component<ReceivingsProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n('Purchase order'), path: 'inventory.inventoriable.code' },
    {
      heading: i18n('Vendor'),
      path: 'inventory.inventoriable.vendorSite.contact.vendor.name'
    },
    { heading: i18n('Item'), path: 'inventory.item.code' },
    { heading: i18n('Description'), path: 'inventory.item.description' },
    { heading: i18n('Quantity'), path: 'quantity' },
    {
      heading: i18n('Created at'),
      path: 'inventory.createdAt',
      date: true,
      tooltip: ['inventory.createdUser.username']
    },
    { heading: i18n('Actions') }
  ]

  constructor (props: ReceivingsProps) {
    super(props)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleLimitChange (limit: string) {
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    this.props.replacePage(page)
  }

  handleCreateClick () {
    this.props.history.push(routes.receivingCreate)
  }

  handleActionClick (id: number, action: ActionName) {
    const { history } = this.props
    if (action === 'view') {
      const pathname = routes.inventory
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'history') {
      const pathname = routes.inventoryHistory
      const state = { id }
      history.push({ pathname, state })
    } else if (action === 'print') {
      const confirm: ConfirmParams = {
        id,
        question: i18n('Are you sure to print the label again?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.handlePrintConfirm(id)
      }
      confirmService.push(confirm)
    } else if (action === 'rollback') {
      const confirm: ConfirmParams = {
        id,
        question: i18n('Are you sure to rollback the last transaction?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.handleRollbackConfirm(id)
      }
      confirmService.push(confirm)
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('This receiving will be entirely removed from the system!'),
        confirmText: i18n('Delete'),
        cancelText: i18n('Cancel'),
        onConfirm: () => this.handleDeleteConfirm(id)
      }
      confirmService.push(confirm)
    }
  }

  handlePrintConfirm (palletId: number) {
    const pallet = find(this.props.data, { id: palletId })
    if (!pallet || !pallet.inventory) return
    inventoryApi.printLabels(pallet.inventory.id, async markups => {
      if (!markups) return
      markups = await WatermarkHelper.applyWatermarks(markups)
      printService.printMarkups(markups)
    })
  }

  handleRollbackConfirm (id: number) {
    palletApi.rollbackTransfer(id, transfer => {
      if (!transfer) return
      alertService.success('Last transfer rollback is done')
      this.props.paginate()
    })
  }

  handleDeleteConfirm (id: number) {
    this.props.deleteReceiving(id)
  }

  componentDidMount () {
    this.props.paginate()
  }

  render () {
    return (
            <ContentLayout>
                <ContentMain layout="full">
                    <Card>
                        <HeadingRow
                            heading={i18n('Receivings')}
                            doc='receivings'>
                            <Button
                                text={i18n('Create')}
                                onClick={this.handleCreateClick}/>
                        </HeadingRow>
                        <DataTable
                            headers={this.headers}
                            data={this.props.data}
                            total={this.props.total}
                            from={this.props.from}
                            to={this.props.to}
                            currentPage={this.props.currentPage}
                            lastPage={this.props.lastPage}
                            limit={String(this.props.limit)}
                            search={this.props.search}
                            onLimtChange={this.handleLimitChange}
                            onSearch={this.handleSearch}
                            onPaginate={this.handlePaginate}
                            onActionClick={this.handleActionClick}/>
                    </Card>
                </ContentMain>
            </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.receivings
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  deleteReceiving,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(Receivings))
